import React, { useState, Fragment } from 'react'
import { connect } from 'react-redux'
import ActionLinks from '../ActionLinks/ActionLinks'
import { MISSION_STATUS_ENUM } from '../../shared/constants'
import { authorization } from '../../Module/Auth/Auth'
import { UNBOOK_OPTIONS } from '../../constants'
import { showReduxModal, hideReduxModal } from '../../Reducers/UI/actions'
import {
  getShowDeleteAllNonStartedModalText,
  onPublishDraftMissions,
  onSetDraftMissionsReadyToPublish,
} from './utils'
import { apiClient } from '../../Module/API/Client'
import InlineSelect from '../Form/SelectDashboard/types/InlineSelect/InlineSelect'
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog'
import { handleConfirmationDialog } from '../../Containers/City/Page/Ambasadors/EmailPipelineView/utils'
import { SnackBarContext } from '../SnackBar'
import { useContext } from 'react'

const NON_STARTED_STATUSES = [
  MISSION_STATUS_ENUM.DRAFT,
  MISSION_STATUS_ENUM.AVAILABLE,
  MISSION_STATUS_ENUM.BOOKED,
]

const MissionsControls = props => {
  const {
    missions,
    campaign,
    updateData,
    // Redux
    showReduxModal,
    isTeamLeaderEnabled = false,
  } = props

  const [unbookReason, setUnbookReason] = useState(UNBOOK_OPTIONS[0].value)
  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })

  const runSnackBar = useContext(SnackBarContext)
  const getActionLinks = () => {
    if (!authorization.isCityManager()) return []
    let actionLinks = []

    const hasDraftMissions = missions.some(
      mission => mission.status === MISSION_STATUS_ENUM.DRAFT,
    )

    const hasNonStartedMissions = missions.some(mission =>
      NON_STARTED_STATUSES.includes(mission.status),
    )

    if (hasDraftMissions) {
      actionLinks.push({
        label: 'Publish all draft missions',
        action: () =>
          onPublishDraftMissions({
            campaign,
            missions,
            showReduxModal,
            updateData,
            isTeamLeaderEnabled,
            runSnackBar,
            hideReduxModal,
          }),
      })
    }

    const hasUnmarkedDraftMissions = missions.some(
      mission =>
        mission.status === MISSION_STATUS_ENUM.DRAFT &&
        !mission.isReadyToPublish,
    )

    if (hasUnmarkedDraftMissions) {
      actionLinks.push({
        label: 'Mark all draft missions ready to publish',
        action: () =>
          onSetDraftMissionsReadyToPublish({
            missions,
            isReadyToPublish: true,
            showReduxModal,
            updateData,
            runSnackBar,
            hideReduxModal,
          }),
      })
    }

    if (hasNonStartedMissions) {
      actionLinks.push({
        label: 'Delete ALL non-started missions',
        action: deleteAllNonStartedMissions,
      })
    }

    return actionLinks
  }

  const deleteAllNonStartedMissions = () => {
    if (campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually delete not-started mission for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else {
      const isAnyBooked = missions.find(
        mission => mission.status === MISSION_STATUS_ENUM.BOOKED,
      )

      const onReasonChange = (e, index, value) => {
        setUnbookReason(value)
      }

      const {
        nonStartedMissionsIds,
        missionsSpyCheckedInIds,
      } = missions.reduce(
        (acc, mission) => {
          if (NON_STARTED_STATUSES.includes(mission.status)) {
            if (
              mission.spyInformation &&
              mission.spyInformation.spyDetails &&
              mission.spyInformation.spyDetails.checkInTime
            ) {
              acc.missionsSpyCheckedInIds.push({ id: Number(mission.id) })
            } else {
              acc.nonStartedMissionsIds.push({ id: Number(mission.id) })
            }
          }
          return acc
        },
        { nonStartedMissionsIds: [], missionsSpyCheckedInIds: [] },
      )

      if (!nonStartedMissionsIds.length && !missionsSpyCheckedInIds.length) {
        return showReduxModal({
          title: 'There is 0 non-started missions that can be deleted',
          confirmLabel: 'OK',
          hideCancel: true,
        })
      }

      const infoText = getShowDeleteAllNonStartedModalText(
        isAnyBooked,
        missionsSpyCheckedInIds,
      )

      return showReduxModal({
        title:
          nonStartedMissionsIds.length === 1
            ? 'Delete 1 non-started mission'
            : `Delete ${nonStartedMissionsIds.length} non-started missions`,
        onConfirm: async () => {
          const payload = {
            unbookReason: unbookReason,
            missions: nonStartedMissionsIds,
          }

          await apiClient.deleteMissions(payload)
          updateData()
        },
        children: isAnyBooked && (
          <div>
            {infoText}
            <InlineSelect
              label={'Reason'}
              name={'unbookMission'}
              value={unbookReason}
              options={UNBOOK_OPTIONS}
              onChange={(e, index, value) => onReasonChange(value)}
              openType={'relative'}
            />
          </div>
        ),
        cancelLabel: 'Cancel',
        confirmLabel: 'Delete All',
      })
    }
  }

  return (
    <Fragment>
      {confirmDialogData.isOpen && <ConfirmDialog {...confirmDialogData} />}
      <ActionLinks items={getActionLinks()} />
    </Fragment>
  )
}

const mapDispatchToProps = {
  showReduxModal,
}

export default connect(
  null,
  mapDispatchToProps,
)(MissionsControls)
